"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupTournamentsBySport = groupTournamentsBySport;
const flow_1 = __importDefault(require("lodash/fp/flow"));
const groupBy_1 = __importDefault(require("lodash/fp/groupBy"));
const map_1 = __importDefault(require("lodash/fp/map"));
const toPairs_1 = __importDefault(require("lodash/fp/toPairs"));
function groupTournamentsBySport(tournaments, sports) {
    return (0, flow_1.default)((0, groupBy_1.default)('sportId'), toPairs_1.default, (0, map_1.default)(([sportId, tournaments]) => ({
        ...sports[sportId],
        tournaments,
    })))(tournaments);
}
//# sourceMappingURL=groupTournamentsBySport.js.map